import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TestService } from 'src/app/_services/test.service';
import { TestStepComponent } from '../test-step.component';

@Component({
  selector: 'app-record-test-case-confirmation',
  templateUrl: './record-test-case-confirmation.component.html',
  styleUrls: ['./record-test-case-confirmation.component.css']
})
export class RecordTestCaseConfirmationComponent  implements OnInit {
  message: any;
  projectType: string = 'WEB';

  constructor(@Inject(MAT_DIALOG_DATA) public data,
  public dialogRef: MatDialogRef<RecordTestCaseConfirmationComponent>,
  private testService:TestService) { 
  
    this.message= data.message;
    //console.log(this.message);
    
  }

ngOnInit() {
}


createNewTest () {
  //console.log('FunctionCalled');
  
  this.testService.setCopyStatus("YES");
  // this.createRecordedData();
}



closeDialog() {
  // this.closeRecordedPage();
  this.dialogRef.close();
}
closeRecordedPage() {
  window.postMessage({
      type: "FROM_STOP_RECORD_PAGE_ONLY"
  }, "*");
}
}
